module.exports = __webpack_public_path__ + "img/medal_svip1.4cc8606.png";